import CASL from '@/utils/constants/casl'

export default {
  path: 'warranty-trx',
  children: [
    {
      path: '',
      name: 'warranty-trx.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.GARANSI
      },
      component: () => import('./list/WarrantyTrxListPage.vue')
    }
  ]
}
